import type { CSSProperties } from "react";

/** 个人资料页：主题色（与 Web ProfileCompleteModal 一致） */
export interface UserProfilePageThemeConfig {
  accent: string;
  accentDark: string;
  accentSoft: string;
  line: string;
  text: string;
  muted: string;
}

/** 个人资料页：布局与字号 */
export interface UserProfilePageLayoutConfig {
  /** 头像直径（px） */
  avatarSize: number;
  /** 昵称最大字数 */
  nicknameMaxLength: number;
  /** 内容区左右内边距（px） */
  paddingX: number;
  /** 内容区上下内边距（px） */
  paddingY: number;
  /** 顶栏「保存」字号（px） */
  saveFontSize: number;
}

export const USER_PROFILE_PAGE_LAYOUT = {
  theme: {
    accent: "#ec407a",
    accentDark: "#d81b60",
    accentSoft: "#fff0f5",
    line: "#f2c0d3",
    text: "#1a1a1a",
    muted: "#6d6d6d",
  },
  layout: {
    avatarSize: 88,
    nicknameMaxLength: 8,
    paddingX: 20,
    paddingY: 28,
    saveFontSize: 15,
  },
} as const satisfies {
  theme: UserProfilePageThemeConfig;
  layout: UserProfilePageLayoutConfig;
};

/** 个人资料页 CSS 变量（注入到 `.user-profile-page`） */
export function userProfilePageCssVars(): CSSProperties {
  const { theme, layout } = USER_PROFILE_PAGE_LAYOUT;
  return {
    ["--user-profile-accent" as string]: theme.accent,
    ["--user-profile-accent-dark" as string]: theme.accentDark,
    ["--user-profile-accent-soft" as string]: theme.accentSoft,
    ["--user-profile-line" as string]: theme.line,
    ["--user-profile-text" as string]: theme.text,
    ["--user-profile-muted" as string]: theme.muted,
    ["--user-profile-avatar-size" as string]: `${layout.avatarSize}px`,
    ["--user-profile-padding-x" as string]: `${layout.paddingX}px`,
    ["--user-profile-padding-y" as string]: `${layout.paddingY}px`,
    ["--user-profile-save-font-size" as string]: `${layout.saveFontSize}px`,
  };
}
